var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 25.6621 18.0791",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclude",
    d: "M12.835 0C12.835 0 20.8586 0.000639647 22.8643 0.543945C23.9686 0.838339 24.8375 1.71176 25.1318 2.8252C25.6661 4.83995 25.6621 9.04199 25.6621 9.04199C25.6621 9.0713 25.6602 13.25 25.1279 15.2578C24.8336 16.367 23.964 17.2412 22.8594 17.54C20.8654 18.0769 12.8885 18.0791 12.8311 18.0791C12.8311 18.0791 4.80293 18.0788 2.80176 17.54C1.69724 17.2456 0.828431 16.3714 0.53418 15.2578C0.00187406 13.25 6.56872e-06 9.07131 5.7142e-09 9.04199C5.7142e-09 9.04199 -0.000592662 4.84072 0.538086 2.82129C0.832368 1.71207 1.70196 0.837905 2.80664 0.539062C4.80063 0.00221901 12.7777 6.92175e-06 12.835 0ZM10.209 12.8584L16.9189 9.04199L10.209 5.22559V12.8584Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYoutube);
export default __webpack_public_path__ + "static/media/icon-youtube.c3c3a5b2bd9f50fd66c71fe6c320ad42.svg";
export { ForwardRef as ReactComponent };